export const environment: {
    baseUrl?: string;
    isDevMode: boolean;
    sanitizeMessages: boolean;
} = {
    baseUrl: import.meta.env.VITE_BASE_URL,
    isDevMode: import.meta.env.DEV,
    sanitizeMessages:
        import.meta.env.VITE_SANITIZE_MESSAGES !== undefined &&
        import.meta.env.VITE_SANITIZE_MESSAGES === true,
};
